var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLiCrSent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campaign",
    transform: "translate(-670.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 24,
    height: 24,
    transform: "translate(670.97)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "person_alert_20dp_FILL0_wght300_GRAD-25_opsz20",
    d: "M136.742-846.434a.54.54,0,0,1-.39-.161.52.52,0,0,1-.165-.385.545.545,0,0,1,.161-.391.517.517,0,0,1,.385-.167.544.544,0,0,1,.391.162.52.52,0,0,1,.167.387.538.538,0,0,1-.162.39A.523.523,0,0,1,136.742-846.434Zm0-2.4a.452.452,0,0,1-.327-.134.44.44,0,0,1-.137-.326v-2.316a.453.453,0,0,1,.133-.328.436.436,0,0,1,.324-.136.454.454,0,0,1,.329.136.443.443,0,0,1,.139.328v2.316a.443.443,0,0,1-.135.326A.445.445,0,0,1,136.74-848.839Zm-7.629,3.717a2.236,2.236,0,0,1-1.644-.671,2.236,2.236,0,0,1-.671-1.644,2.235,2.235,0,0,1,.671-1.644,2.236,2.236,0,0,1,1.644-.671,2.236,2.236,0,0,1,1.644.671,2.235,2.235,0,0,1,.671,1.644,2.236,2.236,0,0,1-.671,1.644A2.236,2.236,0,0,1,129.111-845.122Zm-5.031,4.1v-.3a1.374,1.374,0,0,1,.2-.723,1.548,1.548,0,0,1,.573-.543,9.413,9.413,0,0,1,2.075-.872,7.958,7.958,0,0,1,2.184-.307,7.965,7.965,0,0,1,2.185.307,9.37,9.37,0,0,1,2.075.871,1.547,1.547,0,0,1,.572.544,1.375,1.375,0,0,1,.2.723v.3a.906.906,0,0,1-.274.666.908.908,0,0,1-.667.274h-8.186a.9.9,0,0,1-.664-.274A.912.912,0,0,1,124.08-841.02Zm.925.015h8.211v-.31a.489.489,0,0,0-.088-.281.717.717,0,0,0-.249-.219,8.076,8.076,0,0,0-1.815-.753,7.227,7.227,0,0,0-1.954-.268,7.216,7.216,0,0,0-1.957.268,8,8,0,0,0-1.807.753.709.709,0,0,0-.253.22.489.489,0,0,0-.088.279Zm4.11-5.042a1.328,1.328,0,0,0,.98-.409,1.349,1.349,0,0,0,.405-.984,1.328,1.328,0,0,0-.409-.98,1.349,1.349,0,0,0-.984-.405,1.328,1.328,0,0,0-.98.409,1.349,1.349,0,0,0-.405.984,1.329,1.329,0,0,0,.409.98A1.348,1.348,0,0,0,129.115-846.048ZM129.111-847.456ZM129.111-841.005Z",
    transform: "translate(552.284 858.08)",
    fill: "#8d8d8d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLiCrSent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/liCrSent.e22894a5.svg";
export { ForwardRef as ReactComponent };